import { MeltdownHelper } from "../plugins/MeltdownHelpers";
import { MeltdownSpin } from "../plugins/MeltdownSpin";
import { initLogout } from "../helpers/logout.init";

$(function () {
  let countdownInterval = null;

  // --- Helper Functions ---
  function getCsrfToken() {
    return (
      document.querySelector("input[name='__RequestVerificationToken']")?.value ||
      document.querySelector("meta[name='csrf-token']")?.getAttribute("content") ||
      document.querySelector("#csrf-token")?.value ||
      ""
    );
  }

  function resetUnobtrusive($form) {
    MeltdownHelper?.resetUnobtrusive?.($form);
  }

  function shouldSendCredentials() {
    const v = document.querySelector("meta[name='auth-with-credentials']")?.getAttribute("content");
    return String(v || "").trim() === "1";
  }

  function setFormDisabled($form, state) {
    $form.find("input, textarea, select, button").not(".login-btn").prop("disabled", state);
  }

  function isBusy($btn) {
    return !!($btn && $btn.length && ($btn.data("busy") || $btn.hasClass("btn-loading")));
  }

  function samePath(url) {
    return window.location.pathname === url;
  }

  function navigate(url, text) {
    try {
      window.location.assign(url);
    } catch {}

    setTimeout(() => {
      if (!samePath(url)) return;
      try {
        window.location.replace(url);
      } catch {
        try {
          window.location.href = url;
        } catch {}
      }
    }, 250);

    setTimeout(() => {
      if (!samePath(url)) return;
      try {
        window.location.href = url;
      } catch {}
    }, 2000);
  }

  // --- Global Modal & UI Logic ---
  window.showLegalModal = function () {
    const modal = document.getElementById("legalModal");
    if (modal) {
      modal.classList.remove("hidden");
      document.body.style.overflow = "hidden";
    }
  };

  window.closeLegalModal = function () {
    const modal = document.getElementById("legalModal");
    if (modal) {
      modal.classList.add("hidden");
      document.body.style.overflow = "auto";
    }
  };

  window.acceptAll = function () {
    const $check = $("#policyCheckbox");
    if ($check.length) {
      $check.prop("checked", true);
      if (typeof $.fn.valid === "function") {
        $check.valid();
      }
    }
    window.closeLegalModal();
  };

  window.toggleAuthContent = function (showVerify) {
    const $default = $("#AuthDefaultContent");
    const $verify = $("#VerifyAlert");

    if (showVerify) {
      if (!$verify.hasClass("hidden") && $verify.is(":visible")) return;
      $default.fadeOut(300, function () {
        $verify.hide().removeClass("hidden").fadeIn(400);
      });
    } else {
      if ($verify.hasClass("hidden")) return;
      $verify.fadeOut(300, function () {
        $verify.addClass("hidden");
        $default.hide().fadeIn(400);
      });
    }
  };

  window.toggleProcessingState = function (
    isProcessing,
    message = "Güvenli bağlantı kuruluyor...",
    titleStr = "GÜVENLİK ONAYI",
    subtitleStr = "Sistem İşliyor",
    iconStr = "bx-fingerprint",
  ) {
    const $loginCall = $(".login-call");
    if (!$loginCall.length) return;

    if (isProcessing) {
      // Mevcut içerikleri gizle
      $loginCall.children().hide();

      let $spinner = $loginCall.find(".login-processing");
      if (!$spinner.length) {
        const spinnerHtml = `
          <div class="login-processing flex flex-col items-center lg:items-end w-full text-center lg:text-right animate-in fade-in zoom-in duration-500">
            
            <div class="relative flex items-center justify-center w-24 h-24 mb-6 rounded-full bg-[var(--base-body-highlight-bg)] shadow-[inset_0_4px_10px_rgba(0,0,0,0.05)]">
               <!-- Dıştaki Halka (Hızlı Dönen) -->
               <div class="absolute inset-0 w-full h-full border-[3px] border-transparent border-t-[var(--theme-primary)] border-r-[var(--theme-primary)] rounded-full animate-spin opacity-90"></div>
               
               <!-- İçteki Halka (Ters Yöne Yavaş Dönen) -->
               <div class="absolute top-1.5 left-1.5 w-[calc(100%-12px)] h-[calc(100%-12px)] border-[3px] border-transparent border-b-[var(--text-second)] border-l-[var(--text-second)] rounded-full animate-spin opacity-50" style="animation-direction: reverse; animation-duration: 1.5s;"></div>
               
               <!-- Merkezdeki İkon (Pulse Efektli) -->
               <i class='bx ${iconStr} processing-icon text-4xl text-[var(--theme-primary)] z-10 animate-pulse'></i>
            </div>
            
            <p class="call-txt text-[var(--theme-primary)] mb-2 mt-2 tracking-widest uppercase text-xs font-bold processing-title">${titleStr}</p>
            <p class="call-hd !text-3xl md:!text-4xl mb-3 processing-subtitle">${subtitleStr}</p>
            <p class="call-de !text-base text-[var(--text-second)] processing-msg">${message}</p>
          </div>
        `;
        $loginCall.append(spinnerHtml);
      } else {
        $spinner
          .find(".processing-icon")
          .attr("class", `bx ${iconStr} processing-icon text-4xl text-[var(--theme-primary)] z-10 animate-pulse`);
        $spinner.find(".processing-title").text(titleStr);
        $spinner.find(".processing-subtitle").text(subtitleStr);
        $spinner.find(".processing-msg").text(message);
        $spinner.fadeIn(300);
      }
    } else {
      $loginCall.find(".login-processing").hide();
      // Eğer doğrulama uyarısı açıksa onu göster, değilse varsayılanı göster
      const $verify = $("#VerifyAlert");
      if ($verify.length && !$verify.hasClass("hidden")) {
        $verify.fadeIn(300);
      } else {
        $("#AuthDefaultContent").fadeIn(300);
      }
    }
  };

  // Modal dışına tıklandığında kapatma
  window.onclick = function (event) {
    const modal = document.getElementById("legalModal");
    if (event.target == modal) window.closeLegalModal();
  };

  // --- Verification Logic ---
  function startResendCountdown(seconds) {
    const $resendBtn = $("#VerifyAlert button").first();
    const $btnText = $resendBtn.find("span");
    const originalText = "Doğrulama Kodunu Gönder";

    $resendBtn.prop("disabled", true);
    if (countdownInterval) clearInterval(countdownInterval);

    countdownInterval = setInterval(() => {
      seconds--;
      if (seconds <= 0) {
        clearInterval(countdownInterval);
        $btnText.text(originalText);
        $resendBtn.prop("disabled", false);
      } else {
        const mins = Math.floor(seconds / 60);
        const secs = seconds % 60;
        $btnText.text(`Bekleyin (${mins}:${secs < 10 ? "0" : ""}${secs})`);
      }
    }, 1000);
  }

  window.resendVerificationEmail = function () {
    const $resendBtn = $("#VerifyAlert button").first();
    const csrf = getCsrfToken();

    if (isBusy($resendBtn) || $resendBtn.prop("disabled")) return;

    MeltdownSpin.start($resendBtn);
    $resendBtn.data("busy", true);

    $.ajax({
      url: "/ResendVerification",
      type: "POST",
      headers: { RequestVerificationToken: csrf },
      success: function (res) {
        Toast.success("Bilgilendirme", res.message || "Doğrulama bağlantısı e-posta adresinize gönderildi.");
        startResendCountdown(300);
      },
      error: function (xhr) {
        const errorData = xhr.responseJSON;
        const n = MeltdownHelper.normalizeApiError(xhr);
        Toast.error("İşlem Başarısız", n.message || "Doğrulama bağlantısı gönderilirken bir sorun oluştu.");
        if (xhr.status === 429) startResendCountdown(errorData?.retryAfterSeconds || 300);
      },
      complete: function () {
        MeltdownSpin.stop($resendBtn);
        $resendBtn.data("busy", false);
      },
    });
  };

  // --- Core AJAX Wrapper ---
  function postJson({ url, payload, $btn, formSelector, title, onSuccess, onFail, onAlways }) {
    const activeTitle = title || "Sistem";
    const csrf = getCsrfToken();
    if (!csrf) {
      Toast.error("Güvenlik Uyarısı", "Güvenlik doğrulaması sağlanamadı, lütfen sayfayı yenileyin.");
      onAlways?.();
      return $.Deferred().reject().promise();
    }

    let didNavigate = false;

    let processTitle = "GÜVENLİK ONAYI";
    let processSubtitle = "Sistem İşliyor";
    let processMsg = "Bilgileriniz doğrulanıyor...";
    let processIcon = "bx-fingerprint";

    if (activeTitle === "Giriş") {
      processTitle = "KİMLİK DOĞRULAMA";
      processSubtitle = "Giriş Yapılıyor";
      processMsg = "Güvenli bağlantı kuruluyor, lütfen bekleyin...";
      processIcon = "bx-fingerprint";
    } else if (activeTitle === "Kayıt") {
      processTitle = "HESAP OLUŞTURMA";
      processSubtitle = "Aramıza Katılıyorsunuz";
      processMsg = "Bilgileriniz işleniyor ve hesabınız oluşturuluyor...";
      processIcon = "bx-user-plus";
    } else if (activeTitle === "Güvenlik") {
      processTitle = "GÜVENLİK İŞLEMİ";
      processSubtitle = "Şifre Sıfırlama";
      processMsg = "Bağlantı oluşturuluyor, lütfen bekleyin...";
      processIcon = "bx-shield-quarter";
    } else if (activeTitle.includes("Yenileme")) {
      processTitle = "ŞİFRE İŞLEMLERİ";
      processSubtitle = "Şifre Yenileniyor";
      processMsg = "Yeni şifreniz ayarlanıyor...";
      processIcon = "bx-key";
    }

    const ajaxOpts = {
      url,
      type: "POST",
      contentType: "application/json; charset=utf-8",
      dataType: "json",
      data: JSON.stringify(payload || {}),
      headers: { RequestVerificationToken: csrf },
      beforeSend: function () {
        console.log(`📡 [POST] ${url} isteği gönderiliyor...`, payload);
        if ($btn && $btn.length) $btn.data("busy", true);
        if (window.toggleProcessingState) {
          window.toggleProcessingState(true, processMsg, processTitle, processSubtitle, processIcon);
        }
      },
      success: function (response) {
        console.log(`✅ [POST] ${url} yanıtı alındı:`, response);

        // İşlem başarılı ve yönlendirme varsa kullanıcıya bilgi ver
        if (response?.success && response?.redirect && window.toggleProcessingState) {
          let successMsg = "İşlem başarılı, yönlendiriliyorsunuz...";
          if (activeTitle === "Giriş") successMsg = "Giriş başarılı, yönlendiriliyorsunuz...";
          else if (activeTitle === "Kayıt") successMsg = "Kaydınız alındı, yönlendiriliyorsunuz...";

          window.toggleProcessingState(true, successMsg, processTitle, "İşlem Başarılı!", "bx-check-shield");
        }

        onSuccess?.(response, {
          navigate: (to, text) => {
            didNavigate = true;
            navigate(to, text);
          },
          markNavigated: () => {
            didNavigate = true;
          },
        });
      },
      error: function (xhr) {
        const errorData = xhr.responseJSON;
        console.error(`❌ [POST] ${url} hatası:`, xhr.status, errorData || xhr.responseText);

        if (errorData?.authReason === "EMAIL_NOT_VERIFIED") {
          $("#VerifyAlertText").text(errorData.message);
          window.toggleAuthContent(true);
          Toast.info(activeTitle, errorData.message);
          if (window.toggleProcessingState) window.toggleProcessingState(false);
        } else {
          window.toggleAuthContent(false);
          // Hata durumunda yükleme ekranını kapat
          if (window.toggleProcessingState) window.toggleProcessingState(false);

          if (MeltdownHelper?.handleSubmitValidation && formSelector) {
            MeltdownHelper.handleSubmitValidation(xhr, formSelector, { title: activeTitle });
          } else {
            const n = MeltdownHelper.normalizeApiError(xhr);
            Toast.error("İşlem Başarısız", n.message || "Sistemde geçici bir sorun oluştu. Lütfen daha sonra tekrar deneyin.");
          }
        }
        onFail?.(xhr);
      },
      complete: function () {
        console.log(`🏁 [POST] ${url} işlemi tamamlandı.`);
        if ($btn && $btn.length) $btn.data("busy", false);
        if (!didNavigate) {
          if (window.toggleProcessingState) window.toggleProcessingState(false);
          onAlways?.();
        }
      },
    };

    return $.ajax(ajaxOpts);
  }

  // --- Form Initializers ---
  function initLoginForm() {
    const $form = $("#LoginForm");
    if (!$form.length) return;

    resetUnobtrusive($form);

    $form.off("submit.auth").on("submit.auth", function (e) {
      e.preventDefault();

      const $btn = $form.find(".login-btn");

      // Validation
      if ($form.valid && !$form.valid()) return;

      // Busy check
      if (isBusy($btn)) return;

      // ✅ Formu kilitle
      setFormDisabled($form, true);

      // ✅ Spinner başlat
      MeltdownSpin.start($btn);

      postJson({
        url: "/Login",
        payload: {
          Email: $.trim($form.find("[name='Email']").val() || ""),
          password: $form.find("[name='Password']").val() || "",
          rememberMe: $form.find("[name='RememberMe']").is(":checked"),
        },

        $btn,
        formSelector: "#LoginForm",
        title: "Giriş",

        onSuccess: function (result, ctx) {
          if (!result?.success) {
            Toast.error("Giriş Başarısız", result?.message || "Bilgilerinizi kontrol edip tekrar deneyin.");
            return;
          }

          const target = result?.redirect || "/Panel";
          ctx.navigate(target, "Giriş başarılı. Sisteme yönlendiriliyorsunuz...");
        },

        onAlways: function () {
          // ✅ Spinner kapat
          MeltdownSpin.stop($btn);

          // ✅ Form tekrar aç
          setFormDisabled($form, false);
        },
      });
    });
  }

  function initRegisterForm() {
    const $form = $("#RegisterForm");
    if (!$form.length) return;

    resetUnobtrusive($form);

    $form.off("submit.auth").on("submit.auth", async function (e) {
      console.log("📝 Register form submit tetiklendi.");
      e.preventDefault();

      const $btn = $form.find(".login-btn");

      // Validation
      if (typeof $form.valid === "function" && !$form.valid()) {
        const validator = $form.validate();
        const errors = validator.errorList.map((err) => ({
          field: err.element.name || err.element.id,
          message: err.message,
        }));
        console.warn("⚠️ Form validasyonu başarısız. Hatalı alanlar:", errors);
        return;
      }
      console.log("✅ Form validasyonu başarılı.");

      // Check Password constraints manually
      const val = $form.find('[name="Password"]').val() || "";
      const confirmVal = $form.find('[name="ConfirmPassword"]').val() || "";

      const pwdRules = {
        length: val.length >= 8,
        uppercase: /[A-Z]/.test(val),
        lowercase: /[a-z]/.test(val),
        number: /[0-9]/.test(val),
      };

      const isPwdValid = Object.values(pwdRules).every(Boolean) && val === confirmVal && val.length > 0;

      if (!isPwdValid) {
        console.warn("⚠️ Şifre kuralları karşılanmıyor.");
        Toast.error(
          "Eksik Bilgi",
          "Lütfen şifre oluşturma kurallarının tamamını karşıladığınızdan emin olun.",
        );

        // Show the rules panel to help the user
        const $defaultAuth = $("#AuthDefaultContent");
        const $rulesAuth = $("#AuthPasswordRulesContent");
        if ($rulesAuth.length) {
          $defaultAuth.addClass("hidden").removeClass("flex");
          $rulesAuth.removeClass("hidden").addClass("flex");
        }

        return;
      }

      // Policy Check
      if (!$form.find("#policyCheckbox").is(":checked")) {
        console.warn("⚠️ Sözleşme onay kutusu işaretlenmemiş.");
        Toast.info("Bilgi Gerekli", "Kayıt işlemini tamamlamak için kullanıcı sözleşmelerini onaylamanız gerekmektedir.");
        return;
      }
      console.log("✅ Sözleşmeler onaylı.");

      // Busy Check
      if (isBusy($btn)) {
        console.warn("⚠️ Form zaten işlemde (busy).");
        return;
      }

      console.log("🚀 Kayıt işlemi başlıyor...");
      // ✅ Formu kilitle
      setFormDisabled($form, true);
      MeltdownSpin.start($btn);
      $btn.data("busy", true);

      try {
        console.log("📊 Veriler toplanıyor...");
        // ✅ Verileri DISABLED OLMADAN ÖNCE topla
        const data = {
          firstName: $.trim($form.find('[name="FirstName"]').val()),
          lastName: $.trim($form.find('[name="LastName"]').val()),
          email: $.trim($form.find('[name="Email"]').val()),
          phone: $.trim($form.find('[name="Phone"]').val()),
          tcNo: $.trim($form.find('[name="TcNo"]').val()),
          birthDate: $form.find('[name="BirthDate"]').val(),
          password: $form.find('[name="Password"]').val(),
          confirmPassword: $form.find('[name="ConfirmPassword"]').val(),
          gender: $form.find('[name="Gender"]').val(),
          educationLevel: $form.find('[name="EducationLevel"]').val(),
          policyAccepted: $form.find("#policyCheckbox").is(":checked"),
        };

        // Consent Hash Hesaplama
        const acceptedConsents = [];
        const consentsData = window.registrationConsents || [];

        for (const consent of consentsData) {
          if (!consent.content) continue;

          const contentHash = await computeSHA256Hash(consent.content);

          acceptedConsents.push({
            consentDocumentId: consent.consentDocumentId,
            type: consent.type,
            accepted: true,
            contentHash: contentHash,
          });
        }

        data.acceptedConsents = acceptedConsents;

        // Request
        postJson({
          url: "/Register",
          payload: data,
          $btn,
          formSelector: "#RegisterForm",
          title: "Kayıt",
          onSuccess: function (result, ctx) {
            if (!result?.success) {
              Toast.error("İşlem Başarısız", result?.message || "Kayıt işleminiz şu anda gerçekleştirilemiyor.");
              return;
            }
            Toast.success("Tebrikler!", result.message || "Kayıt işleminiz başarıyla tamamlandı.");
            setTimeout(() => ctx.navigate("/giris?registered=true"), 1500);
          },
          onAlways: function () {
            MeltdownSpin.stop($btn);
            setFormDisabled($form, false);
            $btn.data("busy", false);
          },
        });
      } catch (error) {
        console.error("❌ Register error:", error);
        Toast.error("İşlem Başarısız", error.message || "Sistemsel bir sorun oluştu. Lütfen daha sonra tekrar deneyin.");
        MeltdownSpin.stop($btn);
        setFormDisabled($form, false);
        $btn.data("busy", false);
      }
    });

    // Password Rules Checker
    const $pwObj = $("#Password");
    const $cpwObj = $("#ConfirmPassword");
    const $defaultAuth = $("#AuthDefaultContent");
    const $rulesAuth = $("#AuthPasswordRulesContent");

    if ($pwObj.length) {
      function toggleRulesPanel(show) {
        const $spinner = $(".login-processing");
        if ($spinner.length && $spinner.is(":visible")) return; // Don't override main spinner

        if (show) {
          $defaultAuth.addClass("hidden").removeClass("flex");
          $rulesAuth.removeClass("hidden").addClass("flex");
        } else {
          setTimeout(() => {
            const focusedId = document.activeElement.id;
            if (focusedId !== "Password" && focusedId !== "ConfirmPassword") {
              $rulesAuth.addClass("hidden").removeClass("flex");
              $defaultAuth.removeClass("hidden").addClass("flex");
            }
          }, 100);
        }
      }

      $pwObj.on("focus", () => toggleRulesPanel(true));
      $cpwObj.on("focus", () => toggleRulesPanel(true));
      $pwObj.on("blur", () => toggleRulesPanel(false));
      $cpwObj.on("blur", () => toggleRulesPanel(false));

      function validateAuthPassword() {
        const val = $pwObj.val() || "";
        const confirmVal = $cpwObj.val() || "";

        const rules = {
          length: val.length >= 8,
          uppercase: /[A-Z]/.test(val),
          lowercase: /[a-z]/.test(val),
          number: /[0-9]/.test(val),
        };

        for (const [rule, isValid] of Object.entries(rules)) {
          const el = document.querySelector(`#AuthPasswordRulesContent .rule-item[data-rule="${rule}"]`);
          if (el) {
            const iconContainer = el.querySelector(".icon-container");
            const icon = el.querySelector("i");
            const textSpan = el.querySelector("span");

            if (isValid) {
              icon.className = "bx bx-check text-xl";
              if (iconContainer)
                iconContainer.className =
                  "icon-container flex items-center justify-center w-9 h-9 rounded-full bg-emerald-500/10 text-emerald-500 shrink-0 transition-all duration-300 shadow-inner";
              if (textSpan) textSpan.className = "text-[14px] text-emerald-500 font-bold transition-all duration-300";
              el.style.borderColor = "var(--theme-primary)";
            } else {
              icon.className = "bx bx-x text-xl";
              if (iconContainer)
                iconContainer.className =
                  "icon-container flex items-center justify-center w-9 h-9 rounded-full bg-[var(--base-body-highlight-bg)] text-red-400 shrink-0 transition-all duration-300";
              if (textSpan)
                textSpan.className = "text-[14px] text-[var(--text-second)] font-medium transition-all duration-300";
              el.style.borderColor = "";
            }
          }
        }

        const matchMsg = document.getElementById("password-match-msg");
        if (matchMsg) {
          const isFilled = confirmVal.length > 0;
          const doesMatch = val === confirmVal;

          if (!isFilled) {
            matchMsg.className =
              "mt-4 px-4 py-3.5 rounded-2xl border border-transparent text-[14px] font-bold hidden items-center gap-2 justify-center lg:justify-end transition-all shadow-sm";
          } else if (doesMatch) {
            matchMsg.className =
              "mt-4 px-4 py-3.5 rounded-2xl border border-emerald-500/20 bg-emerald-500/5 text-[14px] font-bold flex items-center gap-2 text-emerald-500 justify-center lg:justify-end transition-all shadow-sm";
            matchMsg.innerHTML = "<span>Şifreler Eşleşir</span> <i class='bx bx-check-double text-xl'></i>";
          } else {
            matchMsg.className =
              "mt-4 px-4 py-3.5 rounded-2xl border border-red-500/20 bg-red-500/5 text-[14px] font-bold flex items-center gap-2 text-red-500 justify-center lg:justify-end transition-all shadow-sm";
            matchMsg.innerHTML = "<span>Şifreler Eşleşmiyor</span> <i class='bx bx-error text-xl'></i>";
          }
        }
      }

      $pwObj.on("input", validateAuthPassword);
      $cpwObj.on("input", validateAuthPassword);
      // Run once on load just in case values were autocompleted
      validateAuthPassword();
    }
  }

  // ✅ SHA-256 hash hesaplama
  async function computeSHA256Hash(text) {
    const encoder = new TextEncoder();
    const data = encoder.encode(text);
    const hashBuffer = await crypto.subtle.digest("SHA-256", data);
    const hashArray = Array.from(new Uint8Array(hashBuffer));
    const hashBase64 = btoa(String.fromCharCode(...hashArray));
    return hashBase64;
  }

  // --- Password Reset Initializers ---

  function initForgotPasswordForm() {
    const $form = $("#ForgotPasswordForm");
    if (!$form.length) return;

    resetUnobtrusive($form);

    $form.off("submit.auth").on("submit.auth", function (e) {
      e.preventDefault();
      const $btn = $form.find(".login-btn");

      if ($form.valid && !$form.valid()) return;
      if (isBusy($btn)) return;

      setFormDisabled($form, true);
      MeltdownSpin.start($btn);

      postJson({
        url: "/ForgotPassword",
        payload: {
          Email: $.trim($form.find("[name='Email']").val() || ""),
        },
        $btn,
        formSelector: "#ForgotPasswordForm",
        title: "Güvenlik",
        onSuccess: function (result) {
          if (!result?.success) {
            Toast.error("İşlem Başarısız", result?.message || "Şifre sıfırlama bağlantısı gönderilemedi.");
            return;
          }
          Toast.success("Bilgi", result.message || "Şifre sıfırlama bağlantısı e-posta adresinize gönderildi.");
          setTimeout(() => navigate("/giris"), 3000);
        },
        onAlways: function () {
          MeltdownSpin.stop($btn);
          setFormDisabled($form, false);
        },
      });
    });
  }

  function initResetPasswordForm() {
    const $form = $("#ResetPasswordForm");
    if (!$form.length) return;

    resetUnobtrusive($form);

    $form.off("submit.auth").on("submit.auth", function (e) {
      e.preventDefault();
      const $btn = $form.find(".login-btn");

      if ($form.valid && !$form.valid()) return;
      if (isBusy($btn)) return;

      setFormDisabled($form, true);
      MeltdownSpin.start($btn);

      postJson({
        url: "/ResetPassword",
        payload: {
          UserId: $form.find("[name='UserId']").val(),
          Token: $form.find("[name='Token']").val(),
          NewPassword: $form.find("[name='NewPassword']").val(),
          ConfirmPassword: $form.find("[name='ConfirmPassword']").val(),
        },
        $btn,
        formSelector: "#ResetPasswordForm",
        title: "Şifre Yenileme",
        onSuccess: function (result, ctx) {
          Toast.success("Tebrikler!", result.message || "Şifreniz başarıyla yenilendi.");
          const target = result.redirect || "/giris";
          ctx.navigate(target, "Şifreniz güncellendi. Giriş sayfasına yönlendiriliyorsunuz...");
        },
        onAlways: function () {
          MeltdownSpin.stop($btn);
          setFormDisabled($form, false);
        },
      });
    });
  }

  const urlParams = new URLSearchParams(window.location.search);
  if (urlParams.get("registered") === "true") {
    const welcomeMsg =
      "Kaydınız başarıyla oluşturuldu. Lütfen e-posta adresinize gönderilen doğrulama linkine tıklayın.";

    // Alert metnini ayarla
    $("#VerifyAlertText").text(welcomeMsg);

    // Giriş metinlerini gizle, doğrulama uyarısını göster
    if (typeof window.toggleAuthContent === "function") {
      window.toggleAuthContent(true);
    }

    startResendCountdown(300);
  }

  initLoginForm();
  initRegisterForm();
  initLogout();
  initForgotPasswordForm();
  initResetPasswordForm();
});
